import { Outlet, Navigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useAuthentication } from '../customHook/useAuthentecation';


function PublicRoutes() {
    const {setAuth}=useAuthentication();
    useEffect(() => {
        sessionStorage.clear();
        setAuth({});
        <Navigate to='/' />
    },[])
    return <Outlet />
}

export default PublicRoutes